import React from 'react';
import { Grid, Tab, Tabs } from '@mui/material';
import UserContext from './context/UsersContext';
import SearchBar from 'Components/SearchBar/index';
import UsersTable from './UsersTable/index';
import UsersSkeleton from './Skeleton/UsersTableSkeleton';
import UsersHeader from './UsersHeader';
import SendingInvitationOptions from './invitations/SendingInvitationOptions';
import { UsersViewTitles } from './constant/UsersViewTitles.enum';
import SendEmailInvitation from './invitations/SendEmail/index';
import SendCSVInvites from './invitations/SendCSVInvites/index';
import useUsersTable from 'hooks/users/useUsersTable';
import InvitationsTable from './InvitationsTable';
import TabPanel from 'Components/Common/TabPanel';

const Users: React.FC = () => {
    const contextValue = useUsersTable();

    const [tab, setTab] = React.useState(0);
    const handleTabChange = (_event: React.SyntheticEvent, newTab: number) => {
        setTab(newTab);
    };

    const showInvitationComponent = () => {
        switch (contextValue?.header.title) {
            case UsersViewTitles.InviteUsers:
                return <SendingInvitationOptions />;
            case UsersViewTitles.InviteUsersViaEmail:
                return <SendEmailInvitation />;
            case UsersViewTitles.InviteUsersViaCSV:
                return <SendCSVInvites />;
            default:
                break;
        }
    };

    return (
        <Grid container spacing={3} justifyContent="end">
            <UserContext.Provider value={contextValue}>
                <UsersHeader />
                {showInvitationComponent()}
                <Grid item xs={12}>
                    <SearchBar
                        onInputChange={contextValue?.setSearchInput}
                        onChange={contextValue?.handleOnSearchBarChange}
                        inputValue={contextValue?.searchInput}
                        values={contextValue?.searchFilters}
                        helperText="Search for user's given name, email, surname"
                        placeholder="Search for someone"
                    />
                    <Tabs onChange={handleTabChange} value={tab}>
                        <Tab label="Users" value={0} />
                        <Tab label="Invitations" value={1} />
                    </Tabs>
                    <TabPanel value={tab} index={0}>
                        {contextValue?.loadingUsers ||
                        contextValue?.users === undefined ? (
                            <UsersSkeleton />
                        ) : (
                            <UsersTable />
                        )}
                    </TabPanel>
                    <TabPanel value={tab} index={1}>
                        {contextValue?.loadingInvites ||
                        contextValue?.invitations === undefined ? (
                            <UsersSkeleton />
                        ) : (
                            <InvitationsTable />
                        )}
                    </TabPanel>
                </Grid>
            </UserContext.Provider>
        </Grid>
    );
};

export default Users;
